import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiSearch, FiUser, FiMenu, FiX, FiMail, FiUsers, FiHelpCircle, FiShare2,FiGrid } from 'react-icons/fi';
import { AiOutlineCalendar } from 'react-icons/ai';
import { BsActivity } from 'react-icons/bs';
import { CgDatabase } from 'react-icons/cg';
import { VscCircleFilled, VscLayoutMenubar } from 'react-icons/vsc';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button, cn } from '@nextui-org/react';
import { IoIosContacts } from 'react-icons/io';
import { PiBagSimpleLight } from 'react-icons/pi';
import { IoSettingsOutline } from 'react-icons/io5';
import { IoExitOutline } from 'react-icons/io5';
import { FaBell } from 'react-icons/fa';
import { removeToken } from '../../../utils/token';
import { BsBuildings } from 'react-icons/bs';

const FAVORITE_MODULES_KEY = 'favoriteModules';

// Modül tanımları - Deck.js ile aynı yapı
const moduleDefinitions = {
  1: {
    title: 'Dashboard',
    icon: BsActivity,
    link: '/dashboard',
    sidebarLabel: 'DASHBOARD',
    sidebarPath: 'dashboard',
    isDefault: true
  },
  2: {
    title: 'Projeler',
    icon: CgDatabase,
    link: '/projects',
    sidebarLabel: 'PROJELER',
    sidebarPath: 'projects',
    isDefault: true
  },
  3: {
    title: 'Takvim',
    icon: AiOutlineCalendar,
    link: '/calendar',
    sidebarLabel: 'TAKVİM',
    sidebarPath: 'calendar',
    isDefault: true
  },
  4: {
    title: 'Notlar',
    icon: VscLayoutMenubar,
    link: '/notes',
    sidebarLabel: 'NOTLAR',
    sidebarPath: 'notes',
    isDefault: true
  },
  5: {
    title: 'Organizasyon',
    icon: BsBuildings,
    link: '/organizations',
    sidebarLabel: 'ORGANİZASYON',
    sidebarPath: 'organizations',
    isDefault: true
  },
  6: {
    title: 'Mail Yönetimi',
    icon: FiMail,
    link: '/mail-management',
    sidebarLabel: 'MAIL',
    sidebarPath: 'mail-management',
    isDefault: false
  },
  7: {
    title: 'Sosyal Medya',
    icon: FiShare2,
    link: '/social-media',
    sidebarLabel: 'SOSYAL MEDYA',
    sidebarPath: 'social-media',
    isDefault: false
  },
  8: {
    title: 'İnsan Kaynakları',
    icon: FiUsers,
    link: '/human-resources',
    sidebarLabel: 'İNSAN KAYNAKLARI',
    sidebarPath: 'human-resources',
    isDefault: false
  },
  9: {
    title: 'Help Desk',
    icon: FiHelpCircle,
    link: '/help-desk',
    sidebarLabel: 'HELP DESK',
    sidebarPath: 'help-desk',
    isDefault: false
  }
};

export default function Leftbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [favoriteModuleIds, setFavoriteModuleIds] = useState([]);
  const location = useLocation();
  const path = location.pathname.substring(1);
  const navigate = useNavigate();

  // localStorage'dan favori modülleri yükle
  useEffect(() => {
    const saved = localStorage.getItem(FAVORITE_MODULES_KEY);
    if (saved) {
      try {
        setFavoriteModuleIds(JSON.parse(saved));
      } catch (e) {
        console.error('Favori modüller yüklenirken hata:', e);
      }
    }
  }, []);

  // localStorage değişikliklerini dinle (Deck sayfasından yapılan değişiklikler için)
  useEffect(() => {
    const handleStorageChange = (e) => {
      const saved = localStorage.getItem(FAVORITE_MODULES_KEY);
      if (saved !== null) {
        try {
          const parsed = JSON.parse(saved);
          const newFavorites = Array.isArray(parsed) ? parsed : [];
          setFavoriteModuleIds(newFavorites);
        } catch (e) {
          console.error('Favori modüller yüklenirken hata:', e);
          setFavoriteModuleIds([]);
        }
      } else {
        setFavoriteModuleIds([]);
      }
    };

    // Custom event ile aynı sayfadan yapılan değişiklikleri dinle
    // Bu event Deck.js'ten gönderiliyor
    const favoriteModulesChangedHandler = (e) => {
      handleStorageChange();
    };
    
    window.addEventListener('favoriteModulesChanged', favoriteModulesChangedHandler);
    
    // Storage event'i sadece başka tablardan yapılan değişikliklerde çalışır
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('favoriteModulesChanged', favoriteModulesChangedHandler);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Favori modülden çıkar
  const removeFavorite = (moduleId, e) => {
    e.preventDefault();
    e.stopPropagation();
    const newFavorites = favoriteModuleIds.filter(id => id !== moduleId);
    setFavoriteModuleIds(newFavorites);
    localStorage.setItem(FAVORITE_MODULES_KEY, JSON.stringify(newFavorites));
    // Custom event gönder
    window.dispatchEvent(new Event('favoriteModulesChanged'));
  };

  const iconClasses = 'text-xl text-default-500 pointer-events-none flex-shrink-0';

  const handlelogout = async () => {
    removeToken('penatoken');
    removeToken('user');
    navigate('/login');
  };

  return (
    <div className={`lg:block z-50 relative`}>
      <div
        className={` vertical-menu w-[80px] left-0 bottom-0 h-screen print:hidden  dark:border-neutral-700 z-10 float-left fixed lg:bg-white lg:dark:bg-dark-500 ${
          isMenuOpen ? '' : 'border-r bg-white dark:bg-dark-500'
        }`}
      >
        <div className="h-screen">
          <div className="w-screen bg-white dark:bg-[#232326] sticky justify-between z-50 h-20 flex flex-row items-center lg:hidden px-10">
            <FiMenu
              className=" text-gray-400 cursor-pointer block lg:hidden "
              size={24}
              onClick={() => {
                setIsMenuOpen(!isMenuOpen)
              }}
            />
            <img src="/assets/penalogo.svg" alt="Logo" className="w-1/12 h-auto" />
            <FaBell className="dark:fill-[#929293] fill-black hover:fill-[#039BE5]  hover:rounded-full hover:shadow-xl" />
          </div>
          <div>
            <div id="leftbar-menu" className={`lg:block ${isMenuOpen ? 'hidden' : 'block'}`}>
              <ul className="metismenu" id="side-menu">
                <li>
                  <ul>
                    <li>
                      <Link
                        to="/dashboard"
                        className={`pl-2 pr-2 py-1 hidden lg:block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600  dark:text-gray-300 dark:active:text-white dark:hover:text-white`}
                      >
                        <img src="/assets/penalogo.svg" alt="Logo" className="w-[35px] h-auto mr-2 ml-4 mt-3 " />
                      </Link>
                    </li>
                    <li className={`border-l-4  ${path === 'dashboard' ? 'border-red-500 dark:border-[#797BF2]' : 'border-white dark:border-[#232326]'}`}>
                      <Link
                        to="/dashboard"
                        className="text-center w-[80px] mb-5 block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600 dark:text-gray-300 dark:active:text-white dark:hover:text-white"
                      >
                        <BsActivity className={`mt-6 text-[20px] mx-auto  ${path === 'dashboard' && 'text-red-500 dark:text-[#797BF2]'}`} />
                        <h1
                          className={`opacity-50 text-[#a1a1aa] text-[8px] font-poppins hover:text-[#E18680] dark:hover:text-[#797BF2] ${
                            path === 'dashboard' && 'text-red-500 dark:text-[#797BF2]'
                          }`}
                        >
                          DASHBOARD
                        </h1>
                      </Link>
                    </li>
                    <li className={`border-l-4  ${path === 'projects' ? 'border-red-500 dark:border-[#797BF2]' : 'border-white dark:border-[#232326]'}`}>
                      <Link
                        to="/projects"
                        className="text-center w-[80px] mb-5 py-1 block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600 dark:text-gray-300 dark:active:text-white dark:hover:text-white"
                      >
                        <CgDatabase className={`text-[20px] mx-auto  ${path === 'projects' && 'text-red-500 dark:text-[#797BF2]'}`} />
                        <h1
                          className={`opacity-50 text-[#a1a1aa] text-[8px] font-poppins hover:text-[#E18680] dark:hover:text-[#797BF2] ${
                            path === 'projects' && 'text-red-500 dark:text-[#797BF2]'
                          }`}
                        >
                          PROJELER
                        </h1>
                      </Link>
                    </li>

                    <li>
                      <ul>
                        <li className={`border-l-4  ${path === 'notes' ? 'border-red-500 dark:border-[#797BF2]' : 'border-white dark:border-[#232326]'}`}>
                          <Link
                            to="/notes"
                            className="text-center w-[80px] mb-5 py-1 block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600 dark:text-gray-300 dark:active:text-white dark:hover:text-white"
                          >
                            <VscLayoutMenubar className={`text-[20px] mx-auto  ${path === 'notes' && 'text-red-500 dark:text-[#797BF2]'}`} />
                            <h1
                              className={`opacity-50 text-[#a1a1aa] text-[8px] font-poppins hover:text-[#E18680] dark:hover:text-[#797BF2]  ${
                                path === 'notes' && 'text-red-500 dark:text-[#797BF2]'
                              }`}
                            >
                              NOTLAR
                            </h1>
                          </Link>
                        </li>
                        <li className={`border-l-4  ${path === 'calendar' ? 'border-red-500 dark:border-[#797BF2]' : 'border-white dark:border-[#232326]'}`}>
                          <Link
                            to="/calendar"
                            className="text-center w-[80px]  mb-5 py-1 block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600 dark:text-gray-300 dark:active:text-white dark:hover:text-white"
                          >
                            <AiOutlineCalendar className={`text-[20px] mx-auto  ${path === 'calendar' && 'text-red-500 dark:text-[#797BF2]'}`} />
                            <h1
                              className={`opacity-50 text-[#a1a1aa] text-[8px] font-poppins hover:text-[#E18680] dark:hover:text-[#797BF2] ${
                                path === 'calendar' && 'text-red-500 dark:text-[#797BF2]'
                              }`}
                            >
                              TAKVİM
                            </h1>
                          </Link>
                        </li>
                        <li className={`border-l-4  ${(path === 'organizations' || path.startsWith('organizations/')) ? 'border-red-500 dark:border-[#797BF2]' : 'border-white dark:border-[#232326]'}`}>
                          <Link
                            to="/organizations"
                            className="text-center w-[80px] mb-5 block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600 dark:text-gray-300 dark:active:text-white dark:hover:text-white"
                          >
                            <BsBuildings className={`mt-6 text-[20px] mx-auto  ${(path === 'organizations' || path.startsWith('organizations/')) && 'text-red-500 dark:text-[#797BF2]'}`} />
                            <h1
                              className={`opacity-50 text-[#a1a1aa] text-[8px] font-poppins hover:text-[#E18680] dark:hover:text-[#797BF2] ${
                                (path === 'organizations' || path.startsWith('organizations/')) && 'text-red-500 dark:text-[#797BF2]'
                              }`}
                            >
                              ORGANİZASYON
                            </h1>
                          </Link>
                        </li>
                        
                        {/* Favori Modüller (Sadece default olmayanlar gösteriliyor ve kaldırılabilir) */}
                        {favoriteModuleIds
                          .filter(id => {
                            const module = moduleDefinitions[id];
                            // Sadece tanımlı ve default olmayan modülleri göster
                            return module && !module.isDefault;
                          })
                          .map(moduleId => {
                            const module = moduleDefinitions[moduleId];
                            if (!module) return null;
                            
                            const IconComponent = module.icon;
                            const isActive = path === module.sidebarPath || path.startsWith(`${module.sidebarPath}/`);
                            
                            return (
                              <li 
                                key={moduleId}
                                className={`border-l-4 ${isActive ? 'border-red-500 dark:border-[#797BF2]' : 'border-white dark:border-[#232326]'}`}
                              >
                                <div className="relative group">
                                  <Link
                                    to={module.link}
                                    className="text-center w-[80px] mb-5 block text-xs font-semibold text-gray-400 transition-all duration-150 ease-linear hover:text-red-600 dark:text-gray-300 dark:active:text-white dark:hover:text-white"
                                  >
                                    <IconComponent className={`mt-6 text-[20px] mx-auto ${isActive && 'text-red-500 dark:text-[#797BF2]'}`} />
                                    <h1
                                      className={`opacity-50 text-[#a1a1aa] text-[8px] font-poppins hover:text-[#E18680] dark:hover:text-[#797BF2] ${
                                        isActive && 'text-red-500 dark:text-[#797BF2]'
                                      }`}
                                    >
                                      {module.sidebarLabel}
                                    </h1>
                                  </Link>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                      <div className="flex gap-1 flex-col absolute bottom-0 right-1 mb-4">
                        <Button
                          variant="light"
                          className={`flex items-center pl-2 pr-2 py-1 text-xs font-medium text-gray-700 transition-all duration-150 ease-linear dark:text-gray-300 dark:active:text-white dark:hover:text-white ${path === 'deck' ? 'text-red-500 dark:text-[#797BF2]' : ''}`}
                          onClick={() => navigate('/deck')}
                        >
                          <FiGrid className={`text-[20px] ml-1 ${path === 'deck' ? 'text-red-500 dark:text-[#797BF2]' : 'text-[#a1a1aa]'}`} />
                        </Button>
                        <Dropdown placement="right-end">
                          <DropdownTrigger>
                            <Button variant="light">
                              <FiUser className="text-[20px] ml-1 cursor-pointer text-[#a1a1aa]" />
                              <VscCircleFilled className="absolute top-0 right-4" size={20} fill="#06d6a0" color="#06d6a0" />
                            </Button>
                          </DropdownTrigger>
                          <DropdownMenu variant="faded" aria-label="Dropdown menu with icons">
                            <DropdownItem
                              key="Profil"
                              description="Profilinizi görüntüleyin"
                              startContent={<FiUser className={iconClasses} />}
                              onClick={() => {
                                navigate('/profile');
                              }}
                            >
                              <p className="font-semibold">Profil</p>
                            </DropdownItem>
                            <DropdownItem
                              key="Organizasyon"
                              onClick={() => {
                                navigate('/organization');
                              }}
                              description="Organizasyon seçin"
                              startContent={<PiBagSimpleLight className={iconClasses} />}
                            >
                              <p className="font-semibold">Organizasyon</p>
                            </DropdownItem>
                            <DropdownItem key="Bağlantılar" description="Bağlantılarınızı düzenleyin" startContent={<IoIosContacts className={iconClasses} />}>
                              <p className="font-semibold">Bağlantılar</p>
                            </DropdownItem>
                            <DropdownItem key="Ayarlar" description="Hesap ayarları" startContent={<IoSettingsOutline className={cn(iconClasses)} />}>
                              <p className="font-semibold">Ayarlar</p>
                            </DropdownItem>
                            <DropdownItem onClick={() => handlelogout()}>
                              <div className="bg-[#da402f] w-full h-10 text-center flex items-center justify-center text-white gap-2 ">
                                <IoExitOutline /> <p> Çıkış Yap</p>
                              </div>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
